import { useMutation, useQuery } from '@apollo/client'
import {
  GET_VIRTUAL_COACHING_REQUEST,
  GET_VIRTUAL_COACHING_REQUESTS,
  GET_VIRTUAL_COACHING_SUMMARY,
  SUBMIT_VIRTUAL_COACHING_RESPONSE,
} from './queries'

export const useVirtualCoachingRequests = () =>
  useQuery(GET_VIRTUAL_COACHING_REQUESTS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all',
  })

export const useVirtualCoachingRequest = requestId =>
  useQuery(GET_VIRTUAL_COACHING_REQUEST, {
    variables: { id: requestId },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  })

export const useVirtualCoachingSummary = ({ skip = false } = {}) =>
  useQuery(GET_VIRTUAL_COACHING_SUMMARY, {
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

export const useSubmitVirtualCoachingResponse = options =>
  useMutation(SUBMIT_VIRTUAL_COACHING_RESPONSE, options)
